import { ReportProblemOutlined as ReportIcon } from '@mui/icons-material'
import { IconButton, Tooltip } from '@mui/material'
import React from 'react'
import { LinkRouter } from '@/helpers/compositions/LinkRouter'
import { T } from '@/helpers/T'

//	///////////////////////
//	MARK: EXPORTS
/**
 * Le bouton « Report » de la barre d'application.
 *
 * Volontairement sans garde de MenuItem : le SMM veut que « everybody within EAPC's operational and
 * technical environment » puisse déposer un rapport, et le subordonner à un rôle Safety reviendrait
 * à le réserver à ceux qui les traitent (décision G du lot S0).
 */
export const NavbarReportButton = React.memo(() => (
  <Tooltip title={<T id='m.safety.report.title' />}>
    <IconButton component={LinkRouter} to='/safety/report' color='inherit' size='small'>
      <ReportIcon />
    </IconButton>
  </Tooltip>
))
